import React, { useEffect, useState } from 'react';
import VBSRegistrationTable from './VBSTable';
import { getVBSRegistrations } from '../sundayupdates/NoticeUpdateService';

const VBSRegistrationList = () => {
  
    const [vbsRegistrations, setVBSRegistrations] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        loadVBSRegistrations();
    }, []);

    const loadVBSRegistrations = () => {
        setLoading(true);
        getVBSRegistrations().then((response) => {
            if (response.data.success) {
                console.log(response.data.data);
                setVBSRegistrations(response.data.data);
            } else {
                setVBSRegistrations([]);
            }
        }).catch((error) => {
            console.error('Error loading VBS registrations:', error);
            setVBSRegistrations([]);
        }).finally(() => {
            setLoading(false);
        });
    };

    const handleRefresh = () => {
        loadVBSRegistrations();
    };

    return (
        <div className="container py-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2 className="mb-0">VBS Registration List</h2>
                <button 
                    className="btn btn-primary"
                    onClick={handleRefresh}
                    disabled={loading}
                >
                    {loading ? 'Loading...' : 'Refresh'}
                </button>
            </div>
            
            <div className="row">
                <div className="col-12">
                    {loading ? (
                        <div className="text-center p-4">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading...</span>
                            </div>
                            <p className="mt-2">Loading registrations...</p>
                        </div>
                    ) : (
                        <VBSRegistrationTable
                            list={vbsRegistrations}
                            onRefresh={handleRefresh}
                        />
                    )}
                </div>
            </div>
        </div>
    );
};

export default VBSRegistrationList;